<template>
  <svg :height="size" :width="size" viewBox="0 0 16 16" fill="none" v-on="$listeners">
    <path :fill="color" d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 4a.5.5 0 0 0-.374.832l4 4.5a.5.5 0 0 0 .748 0l4-4.5A.5.5 0 0 0 12 6H4z"/>
  </svg>
</template>


<script>
export default {
  name: 'IconCaretDownSquareFill',

  props: {
    size: {
      type: String,
      default: '1em',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>